import { Skeleton } from "@mui/material"
import { FC, PropsWithChildren } from "react"

export interface CustomSkeletonProps {
  isLoading?: boolean
  height?: number
}

const CustomSkeleton: FC<PropsWithChildren<CustomSkeletonProps>> = ({ children, isLoading, height = 100 }) => {
  if (!isLoading) {
    return <>{children}</>
  }
  return (
    <Skeleton variant='rectangular' width='100%' height={height}>
      {children}
    </Skeleton>
  )
}

export default CustomSkeleton
